/**
 * Form K - Constants
 * Contains all constant values used in the Controlling Owners form
 */

/**
 * Debounce delay in milliseconds for form change detection
 * Used to throttle onChange callbacks during user input
 */
export const DEBOUNCE_DELAY = 300;

/**
 * Minimum number of controlling owners required
 * At least one controlling owner must be provided
 */
export const MIN_CONTROLLING_OWNERS = 1;
